module.exports = __webpack_public_path__ + "static/media/Grafico.e84435fd.png";